// src/services/magicLinkAuth.js
//
// Envio e conclusão de login por link mágico (Firebase Auth "Email Link
// sign-in"). Usado para o perfil ALTA GESTAO, que nunca define senha.
//
// Pré-requisito: o provedor "Email Link (passwordless sign-in)" precisa
// estar habilitado em Firebase Console > Authentication > Sign-in method.

import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth';
import { auth } from '../firebaseConfig';

const MAGIC_LINK_EMAIL_KEY = 'magoIesgo:linkMagicoEmail';

const buildActionCodeSettings = () => ({
  url: `${window.location.origin}/entrar-link`,
  handleCodeInApp: true,
});

export const enviarLinkMagico = (email) =>
  sendSignInLinkToEmail(auth, email, buildActionCodeSettings()).then(() => {
    // Guardado para o caso de o convidado abrir o link no mesmo navegador
    // sem precisar redigitar o e-mail em /entrar-link.
    window.localStorage.setItem(MAGIC_LINK_EMAIL_KEY, email);
  });

export const isLinkMagicoAtual = () =>
  isSignInWithEmailLink(auth, window.location.href);

export const emailSalvoParaLinkMagico = () =>
  window.localStorage.getItem(MAGIC_LINK_EMAIL_KEY) || '';

export const concluirLoginComLinkMagico = async (email) => {
  const result = await signInWithEmailLink(auth, email, window.location.href);
  window.localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
  return result;
};
